import { Stack, Image, Label } from '@fluentui/react';
import React, { useContext, useEffect, useState } from 'react';
import styles from '../styles/collectie.module.scss';
import { TSet } from '../constants/types';
import { NavLink } from 'react-router-dom';
import GlobalContext from '../_contexts/GlobalContext';
import CountTag from './countTag';

export interface ISetsMenuComponentProps {
    sets: TSet[];
    onSetSelectedSet: Function;
    selectedSetKey: number;
    availableonly: boolean;
}

export interface ISetsMenuComponentState {
    sets : TSet[];
};

const SetsMenuComponent : React.FunctionComponent<ISetsMenuComponentProps> = (props : ISetsMenuComponentProps) => {
    const [sets, setsets] = useState<TSet[]>([]);
    const [countAll, setcountAll] = useState<number>(0);

    const { GlobalImagesVersion, SHOW_ALL_SET, SET_MENU_COLOR } = useContext(GlobalContext);
    
    useEffect(() => {
        CreateSets();
    },[props.availableonly, props.sets]);

    function CreateSets() {
        let sets : TSet[] = [];
        let count = 0;
        props.sets.forEach(set => {
            if (set.productcount > 0) {
                count += set.productcount;
                sets.push(set);
            } else if (!props.availableonly) {
                sets.push(set);
            }
        });
        setcountAll(count);
        setsets(sets);
    }

    return (
        <div style={{objectFit:"contain"}}>
            {SHOW_ALL_SET && <div className={`${styles.setLogoContainer} ${props.selectedSetKey === -9 ? styles.selectedSetLogoMenu : ""}`} style={{backgroundColor:SET_MENU_COLOR}}>
                                <NavLink to="/">
                                    {/* <CountTag count={countAll} children={ */}
                                        <Stack style={{width:"100%",height:window.innerWidth > 950 ? 100 : 40}} horizontalAlign='center' verticalAlign='center' onClick={() => { props.onSetSelectedSet(-9); }}>
                                            <Image className={styles.setLogoMenu} src={process.env.PUBLIC_URL + `/assets/all.webp?v=${GlobalImagesVersion}`} />
                                        </Stack>
                                        {/* }/>  */}
                                </NavLink>
                            </div>}
            {sets.map((set,index) => {
                return  <div className={`${styles.setLogoContainer} ${props.selectedSetKey === set.id ? styles.selectedSetLogoMenu : ""}`} style={{backgroundColor:SET_MENU_COLOR}}>
                            <NavLink to={`/set/${set.name}`}>
                                {/* <CountTag count={set.cardcount} children={ */}
                                    <Stack style={{width:"100%",height:window.innerWidth > 950 ? 100 : 40}} horizontalAlign='center' verticalAlign='center' onClick={() => { props.onSetSelectedSet(set.id); }}>
                                        {/* <Label className={styles.setLogoMenuCountLabel}>{set.cardcount ? set.cardcount : 0}</Label> */}
                                        <Image className={styles.setLogoMenu} src={process.env.PUBLIC_URL + `/assets/products/${set.id.toString()}/${set.id.toString()}.webp?v=${GlobalImagesVersion}`} alt={set.name} />
                                    </Stack>
                                    {/* }/> */}
                            </NavLink>                
                        </div>
            })}
        </div>
    );
}

export default SetsMenuComponent;